import { DefaultService } from '@/services/DefaultService';

/* @71158 */
export default class AgroVisitaItemService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(column, order, page, limit, ...params) {
      return this._http.get(encodeURI(`${this._env}/agro/visitaitem.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
      });
    }

    find(id) {
      return this._http.get(`${this._env}/agro/visitaitem/${id}.json`, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
      });
    }

    findByUuid(uuid) {
      return this._http.get(`${this._env}/agro/visitaitem/uuid/${uuid}.json`, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
      });
    }
    
    save(lista) {
      return this._http.post(`${this._env}/agro/visitaitem`, lista, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw err;
      });
    }

    delete(uuid) {
      return this._http.get(`${this._env}/agro/visitaitem/delete/${uuid}.json`, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
      });
    }

}